import { ConnectionMethod } from 'enums/ConnectionMethodEnum'

export const eligibleAutomationConnections = [
  ConnectionMethod.INTERACTIVE_BROKERS,
  ConnectionMethod.RIA_SUB_ACCOUNT,
]
